import { AppRouteConfig } from '@/types/routes';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import { WorkspaceGuard } from '@/components/auth/WorkspaceGuard';
import { Loading } from '@/components/ui/loading';

// Import route configurations from modular files
import {
  authRoutes,
  dashboardRoutes,
  configurationSection,
  monitoringSection,
  rulesNestedRoutes,
  notFoundRoute,
} from './config';
import { settingsRoutes } from './config/settingsRoutes';

// Define application routes
export const appRoutes: AppRouteConfig[] = [
  // Auth routes
  ...authRoutes,

  // Root path - Protected and requires workspace
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        // Wrap DashboardLayout with WorkspaceGuard
        element: (
          <WorkspaceGuard>
            <DashboardLayout />
          </WorkspaceGuard>
        ),
        children: [
          {
            index: true,
            element: dashboardRoutes[0].element || (
              <div className="flex flex-1 items-center justify-center p-6">
                <Loading />
              </div>
            ),
          },
        ],
      },
    ],
  },

  // All protected routes under /dashboard - also require workspace
  {
    path: '/dashboard',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        // Wrap DashboardLayout with WorkspaceGuard
        element: (
          <WorkspaceGuard>
            <DashboardLayout />
          </WorkspaceGuard>
        ),
        children: [
          // Dashboard routes
          ...dashboardRoutes,
          // Add settings route under dashboard
          ...settingsRoutes,
        ],
      } as AppRouteConfig,
    ],
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      // Main application routes
      {
        path: '',
        element: <DashboardLayout />,
        children: [monitoringSection, ...rulesNestedRoutes, ...settingsRoutes, configurationSection],
      } as AppRouteConfig,
    ],
  },
  // 404 Not Found route (must be last)
  notFoundRoute,
];
